import { render, staticRenderFns } from "./PDPPricingSaveBadge.vue?vue&type=template&id=331a6ad1&scoped=true&"
import script from "./PDPPricingSaveBadge.vue?vue&type=script&lang=js&"
export * from "./PDPPricingSaveBadge.vue?vue&type=script&lang=js&"
import style0 from "./PDPPricingSaveBadge.vue?vue&type=style&index=0&id=331a6ad1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331a6ad1",
  null
  
)

export default component.exports